// extracted by mini-css-extract-plugin
export default {"center":"Button_center__kt2Hk","button":"Button_button__lSdYU","buttonContent":"Button_buttonContent__-bXiL","shine":"Button_shine__+rMf9"};